import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import PlayButton from '../../../../../svg/play-video.svg';
import SimpleLightBox from '../../../../UiComponents/SimpleLightBox/SimpleLightBox';

const PortfolioItem = ({ item, index, playReel, indexPlay }) => {
  const count = ++index;
  const [showLightbox, setShowLightbox] = React.useState(false);
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

  if (!item) {
    return null;
  }

  const handleClick = (e) => {
    if (item?.video?.url) {
      playReel(e, indexPlay);
    }
  };

  const handleImageClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentImageIndex(0);
    setShowLightbox(true);
  };

  const handleCloseLightbox = () => {
    setShowLightbox(false);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev < images.length - 1 ? prev + 1 : prev));
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const imageUrl = item?.image?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src;
  const videoUrl = item?.video?.url ? `https://admin.zerotabletop.com${item?.video?.url}` : null;
  
  const images = [imageUrl, videoUrl].filter(Boolean);

  return (
    <>
      <div
        className="director-portfolio__item-reel"
        onClick={handleClick}
        role="presentation"
        key={item.id}
        id={item.id}
      >
        <div className="director-portfolio__item-reel__background">
          <div
            className="director-portfolio__item-reel__background-owerflow__scroll"
            data-scroll=""
            data-scroll-speed="-1.5"
          >
            <div className="director-portfolio__item-reel__background-owerflow">
              {item?.video?.url && (
                <video
                  src={`https://admin.zerotabletop.com${item?.video?.url}`}
                  playsInline={true}
                  webkit-playsinline=""
                  loading="lazy" 
                  async=""
                  autoPlay={true}
                  muted={true}
                  loop={true}
                  preload="none"
                  className="director-portfolio__item-reel__video"
                ></video>
              )}
              <div 
                onClick={handleImageClick} 
                style={{ cursor: 'pointer' }}
                className="director-portfolio__item-reel__image-wrapper"
              >
                <GatsbyImage 
                  image={item?.image?.localFile?.childImageSharp?.gatsbyImageData} 
                  alt={item?.title} 
                />
              </div>
            </div>
          </div>

          {item?.video?.url && (
            <div className="director-portfolio__item-reel__button">
              <span className="home-videos__slider-item__play-pulse">
                <span className="pulse"></span>
                <PlayButton className="pulse-icon" />
              </span>
            </div>
          )}
        </div>
        <div className="director-portfolio__item-reel__info">
          <span className="director-portfolio__item-reel__info-count">
            {count <= 9 ? '0' + count + ' /' : count + ' /'}
          </span>
          <h2 className="director-portfolio__item-reel__info-title">
            {item.title}
          </h2>
        </div>
      </div>
      {showLightbox && images.length > 0 && (
        <SimpleLightBox
          images={images}
          currentIndex={currentImageIndex}
          onClose={handleCloseLightbox}
          onNext={handleNextImage}
          onPrev={handlePrevImage}
        />
      )}
    </>
  );
};

PortfolioItem.propTypes = {
  playReel: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  indexPlay: PropTypes.number,
};

export default PortfolioItem;
